/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamCoachWithTeam = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        coachType: {
            type: 'CoachTypeEnum',
            isRequired: true,
        },
        team: {
            type: 'TeamSmall',
            isRequired: true,
        },
    },
} as const;
